import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';



@Component({
  selector: 'app-password-reminder',
  templateUrl: './password-reminder.component.html'
})
export class PasswordReminderComponent implements OnInit {

  public email;
  public formGroup: FormGroup;
  public cargando = false;
  public message = '';
  public userInfoParam = { email: '', idUserAuth: '', idUser: '', fecha: {} };


  constructor(private firebaseAuth: FirebaseAuthComponent,
    private cloudFunctions: AngularFireFunctions,
    private firestore: AngularFirestore,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessagesService,
    private afAuth: AngularFireAuth,
    @Inject(DOCUMENT) document: any) {

  }



  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.imdup) {
        const paramsObj = atob(params.imdup).split('-');
        this.userInfoParam.email = paramsObj[0];
        this.userInfoParam.idUserAuth = paramsObj[1];
        this.userInfoParam.idUser = paramsObj[2];
        this.userInfoParam.fecha = new Date(paramsObj[3]);
        console.log(paramsObj, ' ', this.userInfoParam);
        const passwordOriginal = new FormControl('', [Validators.required]);
        const passwordConf = new FormControl('', [Validators.required, this.matchValues('password')]);
        this.formGroup = new FormGroup({ password: passwordOriginal, passwordConfirm: passwordConf });
      } else {
        const emailElement = new FormControl('', [Validators.required, Validators.email]);
        this.formGroup = new FormGroup({ email: emailElement });
      }
    });
  }

  private matchValues(matchTo: string): (AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      return !!control.parent &&
        !!control.parent.value &&
        control.value === control.parent.controls[matchTo].value
        ? null
        : { isMatching: false };
    };
  }

  verifyEmailAndSend(): void {
    this.message = '';
    console.log('el email es ', this.formGroup.value.email);
    this.cargando = true;
    this.firestore.collection('users').ref
      .where('email', '==', this.formGroup.value.email)
      .get()
      .then(usersSnap => {
        if (!usersSnap.empty) {
          usersSnap.forEach(user => {
            const userId = user.id;
            const userData: any = user.data();
            const param = btoa(userData.email + '-' + userData.idUserAuth + '-' + userId + '-' + new Date());
            const url = document.location.href + '?imdup=' + param;
            this.cloudFunctions.httpsCallable('sendEmail')({
              subject: 'Restaurar contraseña',
              message: this.buildMessage(url),
              email: this.formGroup.value.email
            }).toPromise()
              .then((responseSus) => {
                console.log('el resultado de la function es ', responseSus);
                this.cargando = false;
                if (responseSus) {
                  if (responseSus.error) {
                    this.messageService.openAlertDialog('Hubo un error al enviar el correo' + responseSus.error, 'Error consultando');
                  } else {
                    this.message = `Te hemos enviado un correo a ${this.formGroup.value.email} para restaurar tu contraseña.
                     Si no lo recibes, por favor verifica la bandeja de correos no deseados o Spam`;
                  }
                }
                return responseSus;
              }).catch(error => {
                this.cargando = false;
                this.messageService.openAlertDialog('Hubo un error al enviar el correo' + error, 'Error consultando');
              });
            console.log('el usuario consultado es', userData, ' \n', url);
          });
        } else {
          this.cargando = false;
          this.messageService.openAlertDialog('La cuenta de correo introducida no existe en nuestra base de datos. Por favor revísalo e inténtalo de nuevo.', 'Error');
        }
      });
  }

  verifyPageState(): void {
    if (this.userInfoParam?.email) {
      this.modificarPassword();
    } else {
      this.verifyEmailAndSend();
    }
  }

  backToMain() {
    this.router.navigate(['/']);
  }

  modificarPassword(): void {
    this.message = '';
    this.cargando = true;
    this.firestore.collection('users').ref
      .where('email', '==', this.userInfoParam.email)
      .get()
      .then(usersSnap => {
        usersSnap.docs
        if (!usersSnap.empty) {
          let password = '';
          usersSnap.forEach(user => {
            password = user.get("password");
          });
          if (password) {
            this.afAuth.signInWithEmailAndPassword(this.userInfoParam.email, password)
              .then(userLogin => {

                const formToSave = { password: btoa(this.formGroup.value.password) };
                this.firestore.collection('users').doc(this.userInfoParam.idUser).update(formToSave).then(x => {
                  userLogin.user.updatePassword(btoa(this.formGroup.value.password)).then(change => {
                    this.cargando = false;
                    this.message = `Su contraseña ha sido modificada correctamente`;
                  }).catch(erro => {
                    this.cargando = false;
                    this.messageService.openAlertDialog('Hubo un error al guardar el password ' + erro, 'Error');
                  });
                }).catch(erro => {
                  this.cargando = false;
                  this.messageService.openAlertDialog('Hubo un error al guardar el password ' + erro, 'Error');
                });
              }).catch(error => {
                this.cargando = false;
                this.messageService.openAlertDialog('Hubo un error con el usuario ' + error, 'Error');
              });
          }
        } else {
          this.cargando = false;
          this.messageService.openAlertDialog('La cuenta de correo introducida no existe en nuestra base de datos. Por favor revísalo e inténtalo de nuevo.', 'Error');
        }
      });
  }

  buildMessage(url: string): string {
    const text = `
    <div style="width:800px;  display: block; align-items: center;border: 2px solid #ccc; margin: 1rem; padding: 1rem;">
      <div style="text-align: left;  width:180px; height:60px;">
        <img class="product-image" style="max-width: 100%;"
        src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
      </div>
      <div>
        <p>Por favor ir al siguiente enlace para cambiar su contraseña: ${url}<br></p>
      </div>
    </div>`;

    return text;
  }
}
